import { Roles } from "./Enums";

export class DocumentFilter {
  famCode: string;
  filterValue: string;
  role: string;
  roleId: Roles;
}
